import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ContentfulService } from '../contentful.service';
import { Entry } from 'contentful';

@Component({
  selector: 'app-contact-list',
  templateUrl: './contact-list.component.html',
  styleUrls: ['./contact-list.component.css'],
  standalone: false
})
export class ContactListComponent implements OnInit {

  contacts: Entry<any>[] = [];

  constructor(
    private readonly contentfulService: ContentfulService,
    private readonly cdr: ChangeDetectorRef
  ) { }

  ngOnInit() {
    this.contentfulService.getContacts()
    .then(contacts => {
      this.contacts = contacts;
      this.cdr.detectChanges();
    })

  }

}
